import React from 'react';
import { Box, Chip, useMediaQuery, useTheme } from '@mui/material';
import { lightColours } from '../../../styles/colours';

const LatestFigures = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    // Define the font size for the strong element (changed from 'px' to '16px')
    const updatedStrong = (
        <strong style={{ color: lightColours.purpleText }}>
            Updated for 2025/2026
        </strong>
        );

  // Use a condensed message on mobile devices.
  const labelText = isMobile 
    ? <>Latest HMRC figures – {updatedStrong}</>
    : <>Calculations based on the latest HMRC figures – {updatedStrong}</>;

  return (
    <Box sx={{ textAlign: 'center', mb: 2 }}>
      <Chip
        label={
          <span style={{ wordBreak: 'break-word' }}>
            {labelText}
          </span>
        }
        sx={{
          backgroundColor: lightColours.lightPink2,
          fontSize: '18px',
          padding: '6px 16px 8px',
          maxWidth: '100%',
          display: 'inline-block',
        }}
      />
    </Box>
  );
};

export default LatestFigures;
